/** Hierarchical query keys: invalidating a prefix (e.g. ['drive']) refreshes every dependent view. */
export const qk = {
    authProviders: ['auth', 'providers'] as const,
  me: ['me'] as const,
  sessions: ['me', 'sessions'] as const,
  drive: {
    all: ['drive'] as const,
    list: (folderId: string | undefined, filters: object = {}) => ['drive', 'list', folderId ?? 'root', filters] as const,
    view: (view: 'shared' | 'recent' | 'starred' | 'trash' | 'spam', filters: object = {}) => ['drive', 'view', view, filters] as const,
    blocked: ['drive', 'blocked'] as const,
    people: ['drive', 'people'] as const,
    suggested: ['drive', 'suggested'] as const,
    storage: ['drive', 'storage'] as const,
    feed: (params: object) => ['drive', 'feed', params] as const,
    trashedFolder: (id: string) => ['drive', 'trashedFolder', id] as const,
    search: (params: object) => ['drive', 'search', params] as const,
    library: (params: object) => ['drive', 'library', params] as const,
    file: (id: string) => ['drive', 'file', id] as const,
    folder: (id: string) => ['drive', 'folder', id] as const,
    versions: (id: string) => ['drive', 'versions', id] as const,
    activity: (kind: string, id: string) => ['drive', 'activity', kind, id] as const,
    sharing: (kind: string, id: string) => ['drive', 'sharing', kind, id] as const,
  },
  docs: {
    one: (id: string) => ['docs', id] as const,
    comments: (id: string) => ['docs', id, 'comments'] as const,
    suggestions: (id: string) => ['docs', id, 'suggestions'] as const,
    versions: (id: string) => ['docs', id, 'versions'] as const,
    collaborators: (id: string) => ['docs', id, 'collaborators'] as const,
  },
  sheets: {
    one: (id: string) => ['sheets', id] as const,
    versions: (id: string) => ['sheets', id, 'versions'] as const,
    comments: (id: string, sheetId: string) => ['sheets', id, 'comments', sheetId] as const,
  },
  forms: {
    one: (id: string) => ['forms', id] as const,
    responses: (id: string) => ['forms', id, 'responses'] as const,
    analytics: (id: string, days: number) => ['forms', id, 'analytics', days] as const,
    public: (publicId: string) => ['publicForm', publicId] as const,
  },
  notifications: ['notifications'] as const,
  /** Everything under ['admin'] is refreshed after any admin change. */
  admin: {
    all: ['admin'] as const,
    overview: ['admin', 'overview'] as const,
    alerts: ['admin', 'alerts'] as const,
    users: (params: object) => ['admin', 'users', params] as const,
    user: (id: string) => ['admin', 'user', id] as const,
    policies: ['admin', 'policies'] as const,
    storage: ['admin', 'storage'] as const,
    content: (params: object) => ['admin', 'content', params] as const,
    audit: (params: object) => ['admin', 'audit', params] as const,
    activity: (params: object) => ['admin', 'activity', params] as const,
    security: ['admin', 'security'] as const,
    sessions: (params: object) => ['admin', 'sessions', params] as const,
    system: ['admin', 'system'] as const,
    email: ['admin', 'email'] as const,
  },
};
